module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lines_layer_off-b904b466593b613e402c773b9231f0dd.png";